<div class="row d-flex">
  <div class="col-6 col-lg-3 mr-auto p-0">
    <h1>
      <mdb-icon fas icon="tasks"></mdb-icon> Confirmación de Notas de Venta
    </h1>
  </div>
  <div class="col-6 col-lg-6 pb-1">
    <!-- COMPONENTE CARD VIEW FOLIOS -->
    <app-view-folios [codigos_dte]="codigos_dte" [contadorFacturas]="contadorFacturas"></app-view-folios>
  </div>
</div>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Facturación masiva</span>
      <span> /</span>
      <span>Confirmación de Notas de Venta</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <form [formGroup]='formHeader' novalidate>
    <div class="card-body justify-content-between">
      <div class="row filtros-body">

        <div class="col dato">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fechaEmision" [placeholder]="'Fecha emisión'" required
              formControlName="fechaEmision">
            </mdb-date-picker>
            <div *ngIf="
                      formHeader.get('fechaEmision').invalid &&
                      (formHeader.get('fechaEmision').dirty ||
                      formHeader.get('fechaEmision').touched)
                  ">
              <mdb-error *ngIf="formHeader.get('fechaEmision').hasError('required')">
                Ingrese fecha emisión
              </mdb-error>
            </div>
          </div>
        </div>

        <div class="col dato">
          <Strong class="title">Fecha</Strong>
          <div class="btn-toolbar" role="toolbar">
            <div class="btn-group mr-2 value" role="group">{{headerData?.fecha_inicio_busqueda | fecha}}</div>
            <div class="btn-group mr-2 value" role="group">{{headerData?.fecha_termino_busqueda | fecha}}</div>
          </div>
        </div>

        <!-- <div class="col dato">
          <div class="md-form">
              <mdb-date-picker [inline]="true" name="fechahasta" [placeholder]="'Hasta'" required
              formControlName="fechaHasta"></mdb-date-picker>
              <div *ngIf="
                      formHeader.get('fechaHasta').invalid &&
                      (formHeader.get('fechaHasta').dirty ||
                      formHeader.get('fechaHasta').touched)
                    ">
                  <mdb-error *ngIf="formHeader.get('fechaHasta').hasError('required')">Ingrese fecha hasta
                  </mdb-error>
              </div>
          </div>
      </div> -->
        <div class="col dato">
          <div class="md-form">
            <mdb-select [options]="optionsVendedor" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Vendedor" formControlName="vendedor"></mdb-select>
            <label>Vendedor</label>
          </div>
        </div>
        <div class="col dato">
          <div class="md-form">
            <mdb-select label="Comuna" [options]="optionsComunas" placeholder="Comuna" [filterEnabled]="true"
              [multiple]="true" formControlName="comuna"></mdb-select>
          </div>
        </div>



        <div class="col dato">
          <Strong class="title">Bodega</Strong>
          <span class="value">{{headerData?.nombreBodega}}</span>
        </div>
        <div class="col dato">
          <Strong class="title">Pedidos a Facturar</Strong>

          <span class="value">{{docSeleccionado}}</span>
          <!-- <span class="value">{{headerData?.nroPedidos}}</span> -->
        </div>
        <!-- <div class="col dato">
        <Strong class="title">Total Quiebres</Strong>
        <span class="value">99</span>
      </div> -->
      </div>
    </div>

    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div></div>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </form>
  <!-- FOOTER -->
  <!-- <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
    <div></div>
    <button mdbBtn type="button" size="sm" color="secondary" mdbWavesEffect>
      Analizar pedidos
    </button>
  </div> -->
</div>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="table-responsive" *ngIf="listaMovimientos">
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaMovimientos">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">
              <mdb-checkbox (change)="checkAllChange($event)" [(ngModel)]="checkAll"></mdb-checkbox>
            </th>
            <th scope="col">Nota de venta</th>
            <th scope="col">Fecha</th>
            <th scope="col">RUT</th>
            <th scope="col">Nombre cliente</th>
            <th scope="col">Comuna</th>
            <th scope="col">Vendedor</th>
            <th scope="col">Total</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loading">
            <td colspan="100%" style="text-align: center">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
          </tr>
          <tr *ngIf="!loading && listaMovimientos?.length === 0">
            <td colspan="100%" style="text-align: center">
              No se encontró información
            </td>
          </tr>
          <tr *ngFor="let mov of listaMovimientos; let i = index; ">
            <td>
              <mdb-checkbox [checked]="mov.checked" (change)='checkDetalle(mov, $event)'>
              </mdb-checkbox>
            </td>
            <td>{{mov.folio}}</td>
            <td>{{mov.fecha_registro | fecha}}</td>
            <td>{{mov.rutFormato | rut}}</td>
            <td>{{mov.nombrecliente}}</td>
            <td>{{mov.comuna}}</td>
            <td>{{mov.vendedor_nombre}}</td>
            <td>$ {{mov.totalBruto | numerico}}</td>
            <td>
              <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                (click)="loadAndShowVerPedidos(mov)" mdbTooltip="Ver" placement="right">
                <mdb-icon fas icon="eye"></mdb-icon>
              </button>
            </td>
          </tr>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>
    <div class="table-responsive" *ngIf="listaMovimientos?.length > 0">
      <table class="table table-striped table-hover table-sm align-middle">
        <tbody style="text-align:right;">
          <tr>
            <td class="col-8" style="font-weight: bold; font-size: 15px;">
              <span style="color: red;">Total Neto </span>
              <span>$ {{sumMontoNeto | numerico}}</span>
            </td>
            <td class="col-4" style="font-weight: bold; font-size: 15px;">
              <span style="color: red;">Total Bruto </span>
              <span>$ {{sumMontoBruto | numerico}}</span>
            </td>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- *ngIf="listaMovimientos?.length > 0" -->
<div class="card mb-2 wow" *ngIf="listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <!-- <a routerLinkActive="active" mdbBtn type="button" color="success" mdbWavesEffect (click)="showModalConfirm()">
      Generación de Facturas
    </a> -->
    <!-- <app-api-button [processing]="processing" (click2)="showModalConfirmNotificacion()">
      Notificación de Generación de Facturas
    </app-api-button> -->
    <app-api-button [processing]="processing" (click2)="showModalConfirm()">
      Generación de Facturas
    </app-api-button>
  </div>
</div>

<!-- MODAL verPedido -->
<app-confirmar-nota-venta-modal-ver-pedido></app-confirmar-nota-venta-modal-ver-pedido>

<!-- MODAL confirm -->
<app-modal-confirm title="Convertir a Facturas"
  contentText="¿Desea convertir las notas de venta en facturas, con fecha {{this.formHeader.get('fechaEmision').value| fecha}}?">
</app-modal-confirm>

<!-- MODAL ver resultado -->
<app-confirmar-nota-venta-modal-resultado
  (ActualizarFiltro)="UpdateFiltro()"></app-confirmar-nota-venta-modal-resultado>
<app-modal-ver-errores></app-modal-ver-errores>
<!-- MODAL verAdvertencia -->
<!-- <app-confirmar-nota-venta-modal-ver-advertencia></app-confirmar-nota-venta-modal-ver-advertencia> -->
